import React from "react";
import { withShowIf } from "../../../../../../../../components/with-show-if/with-show-If.component";
import { Message } from "./flyer-detail-page-tab-no-pages-message.styles";

export const FlyerDetailPageTabNoPagesMessage = withShowIf(() => <Message>No pages added</Message>);
